import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { List, AddEdit, ChangePassword } from './';

export { UsersLayout };

function UsersLayout() {
    return (
        <div className="p-4">
            <div className="container">
                <Routes>
                    <Route index element={<List />} />
                    <Route path="add" element={<AddEdit />} />
                    <Route path="edit/:id" element={<AddEdit />} />
                    <Route path="customer/:customerId" element={<List />} />
                    <Route path="change_password" element={<ChangePassword />} />
                </Routes>
            </div>
        </div>
    );
}
